<template>
	<Card>
		<Row :gutter="16">
			<Col span="24">
			<div class="global-tool-bar">
				<div class="left-bar">
					<span class="title">PC广告设置</span>
				</div>
				<div class="right-bar">
					<Button size="small" class="btns" shape="circle" type="success" icon="ios-add-circle-outline"
						@click="onAdCreate">新增</Button>
				</div>
			</div>
			</Col>
		</Row>

		<Modal v-model="adFormShow" title="广告信息">

			<Form label-position="top">
				<Row :gutter="16">
					<Col>
					<FormItem label="广告图" prop="picUrl">
						<single-file-upload-with-name v-model="adForm.picUrl" :imgHeight="150" :imgWidth="150" />
				 </FormItem>
					</Col>
				</Row>
				<Row :gutter="16">
					<!-- <Col span="8">
					<FormItem label="投放位置">
						<Select v-model="adForm.location">
							<Option :value="AD_TYPE_PC">{{ AD_TYPE_PC }}</Option>
						</Select>
					</FormItem>
					</Col> -->
					<Col span="8">
					<FormItem label="显示顺序">
						<InputNumber :max="10" :min="1" v-model="adForm.sort"></InputNumber>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="16">
					<Col>
					<FormItem label="是否启用">
						<RadioGroup v-model="adForm.enable">
							<Radio :label="1">启用</Radio>
							<Radio :label="0">停用</Radio>
						</RadioGroup>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="16">
					<Col>
					<FormItem label="备注">
						<Input v-model="adForm.remark" type="textarea"></Input>
					</FormItem>
					</Col>
				</Row>

			</Form>
			<div slot="footer">
				<Button type="success" class="form-button" @click="onSave">保存</Button>
				<Button type="text" class="form-button" @click="onCancel">取消</Button>
			</div>
		</Modal>

		<Row :gutter="16">
			<Col span="24">
			<stand-pagination-table :columns="mainTable.columns" :data="mainTable.data" :loading="mainTable.loading"
				:table-search="mainTable.tableSearch" :table-load-event="getAdTableRecords" />
			</Col>
		</Row>
	</Card>
</template>

<script>
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import {
    singleImageRender
} from '@/libs/tableRowImageRender';
import SingleFileUploadWithName from '@/components/single-file-upload-with-name/SingleFileUploadWithName';
import {
    FORM_EDIT_MODE_CREATE,
    FORM_EDIT_MODE_MODIFY
} from '@/view/mixins/form-edit-mode';
import {
    AD_TYPE_PC
} from '@/view/system-management/ad-management/AdTypeDefine';

import {
    getAdList,
    saveAd
} from '@/api/modules/system-management/ad-management';
import {
    dateTimeRender,
    dateRender
} from '@/libs/tableRowTimeRender';

export default {
    name: 'AppAd',
    components: {
        StandPaginationTable,
        SingleFileUploadWithName
    },
    data() {
        return {
            AD_TYPE_PC,
            adForm: {
                formEditMode: '',
                adUuid: '',
                location: AD_TYPE_PC,
                remark: '',
                enable: 0,
                sort: 1
            },
            adFormShow: false,
            mainTable: {
                columns: [{
                    title: '行号',
                    type: 'index',
                    width: 80,
                    align: 'center'
                },
                {
                    title: '广告图',
                    align: 'center',
                    render: (h, params) => singleImageRender(h, params.row.picUrl)
                },
                {
                    title: '投放位置',
                    key: 'location',
                    align: 'center'
                },
                {
                    title: '创建时间',
                    key: 'createTime',
                    align: 'center',
                    render: (h, params) => dateTimeRender(h, params.row.createTime)
                },
                {
                    title: '备注',
                    key: 'remark',
                    align: 'center'
                },
                {
                    title: '是否启用',
                    key: 'enable',
                    align: 'center',
                    render: (h, params) => {
                        let text = params.row.enable === 1 ? '是' : '否';
                        let color = params.row.enable === 1 ? '' : 'red';
                        return h('div', [
                            h('span', {
                                style: {
                                    color: color
                                }
                            }, text)
                        ]);
                    }
                },
                {
                    title: '显示顺序',
                    key: 'sort',
                    align: 'center'
                },
                {
                    title: '操作',
                    key: 'action',
                    align: 'center',
                    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small'
                                },
                                style: {},
                                on: {
                                    click: () => {
                                        this.onAdUpdate(params.row);
                                    }
                                }
                            }, '编辑')
                        ]);
                    }
                }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted() {
        this.getAdTableRecords();
    },
    methods: {
        getAdTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "location");
            this.mainTable.tableSearch.filters.enable = true;
            this.mainTable.tableSearch.filters.conditions.push({
				    name: 'location',
				    type: 'eq',
				    value: 'PC广告'
            });
            getAdList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.tableLoading = false;
            }).catch(() => {
                this.mainTable.tableLoading = false;
            });
        },
        onAdCreate() {
            this.adForm.formEditMode = FORM_EDIT_MODE_CREATE;
            this.adForm.id = '';
            this.adForm.remark = '';
            this.adForm.enable = 1;
            this.adForm.sort = 1;
            this.adFormShow = true;
        },
        onAdUpdate(row) {
            this.adForm.formEditMode = FORM_EDIT_MODE_MODIFY;
            this.adForm.id = row.id;
            this.adForm.remark = row.remark;
            this.adForm.enable = row.enable;
            this.adForm.sort = row.sort;
            this.adForm.picUrl = row.picUrl;
            this.adFormShow = true;
        },
        onCancel() {
            this.adFormShow = false;
        },
        onSave() {
            const data = Object.assign({}, this.adForm);
			 saveAd(data).then(res => {
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '保存成功',
                        onOk: () => {
                            this.adFormShow = false;
                            this.getAdTableRecords();
                        }
                    });
                }
            });
        }
    }
};
</script>

<style>
</style>
